import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { IconSize } from "../../enums";
import { IconButton } from "../button";
import { AttachmentIcon, CloseIcon, ColoredIcon } from "../icon";
import { AttachmentText, ClickableStyled, MessageFileStyled } from "./ChatMessage.styles";
import Tooltip from "@components/tooltip";

interface IProps {
    id: number;
    name: string;
    onClick: (id: number) => void;
    onRemove?: (id: number) => void;
}

const MessageFile: React.FC<IProps> = ({ id, name, onClick, onRemove }) => {
    const { t } = useTranslation("Components");

    const handleClick = useCallback(() => {
        onClick(id);
    }, [id, onClick]);

    const handleRemove = useCallback(() => {
        onRemove(id);
    }, [id, onRemove]);

    return (
        <MessageFileStyled key={id}>
            <ClickableStyled onClick={handleClick} isLink>
                <ColoredIcon><AttachmentIcon width={IconSize.XS} height={IconSize.XS}/></ColoredIcon>
                <Tooltip content={name} onlyShowWhenChildrenOverflowing>
                    {(ref) => (
                        <AttachmentText ref={ref}>
                            {name}
                        </AttachmentText>
                    )}
                </Tooltip>
            </ClickableStyled>
            {onRemove && (
                <IconButton title={t("Components:ChatMessageInput.RemoveFile")}
                            onClick={handleRemove}
                            isDecorative>
                    <CloseIcon width={IconSize.XS} height={IconSize.XS}/>
                </IconButton>
            )}
        </MessageFileStyled>
    );
};

export default MessageFile;